var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value !== null
    ? _c("section", { staticClass: "data mb10" }, [
        _c(
          "div",
          { attrs: { id: _vm.targetId } },
          [
            _c("p", { staticClass: "h-style-02", class: _vm.titleClass }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ]),
            _vm._v(" "),
            _c("job-preview-content-data-tooltip"),
            _vm._v(" "),
            _c("div", { staticClass: "container bar-graph fwB mt20" }, [
              _c("div", [
                _c("div", { staticClass: "graph" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bar",
                      style:
                        "height: " +
                        _vm.averageHight +
                        "px; margin-top: " +
                        (_vm.graphHight - _vm.averageHight) +
                        "px;",
                      attrs: { "data-test": "average" },
                    },
                    [
                      _c("p", [
                        _c("span", [_vm._v(_vm._s(_vm.averageValue))]),
                        _c("span", [_vm._v(_vm._s(_vm.unit))]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bar this",
                      style:
                        "height: " +
                        _vm.thisHight +
                        "px; margin-top: " +
                        (_vm.graphHight - _vm.thisHight) +
                        "px;",
                    },
                    [
                      _c("p", [
                        _c("span", [_vm._v(_vm._s(_vm.value))]),
                        _c("span", [_vm._v(_vm._s(_vm.unit))]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label-horizontal" }, [
      _c("div", { staticClass: "user-label" }, [
        _vm._v("\n            全国平均\n          "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-label" }, [
        _vm._v("\n            当社\n          "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }